import React from 'react';

import PropTypes from 'prop-types';
import { SelectField } from '../SelectField';


export class YesNoSelect extends React.Component {
    static propTypes = {
        isInline: PropTypes.bool,
        value: PropTypes.bool,
    };

    getSource = () => {
        let { trans } = this.props;

        return [
            { value: true, text: trans('yes') },
            { value: false, text: trans('no') },
        ].filter((v) => v);
    };

    handleSelect = (value) => {
        this.props.onChange(value);
    };

    render() {
        return (
            <SelectField
                title={this.props.title}
                tooltip={this.props.tooltip}
                value={this.props.value === null ? null : this.props.value}
                onChange={this.handleSelect}
                allowBlank={this.props.allowBlank}
                isInline={this.props.isInline}
                options={this.getSource()}
                validationMessage={this.props.validationMessage}
                isReadonly={this.props.isReadonly}
                isAutocomplete={false}
                multiSelect={false}
                trans={this.props.trans}
                isinvalid={this.props.isinvalid}
                type={this.props.type}

            />
        );
    }
}
